import { type ComponentProps, type FC, memo, useEffect } from 'react'
import type { SelectableListMenu } from '@platform/ui'
import { TOCMenuItemComponent } from './TOCMenuItemComponent'
import { useTOCMenuItem } from './useTOCMenuItem'
import type { SelectableListMenuDataWithMetadata } from '../../tocMenuSlice'

type SelectableListMenuProps = ComponentProps<typeof SelectableListMenu>

type Props = {
  element: SelectableListMenuDataWithMetadata
  dispatch: Parameters<SelectableListMenuProps['children']>[number]
  inlinedToComposition?: boolean
}

export const TOCMenuItem: FC<Props> = memo(({ element, dispatch, inlinedToComposition }) => {
  const properties = useTOCMenuItem()

  const { isSelected, isCompleted, isDraft, isLocked, isExpanded, isPassed, isOptional } = properties({
    activityPart: element.metadata?.activityPart,
  })

  useEffect(() => {
    // first enable all items
    dispatch({ type: 'ENABLE', id: element.id })

    if (isSelected) {
      dispatch({ type: 'SELECT', id: element.id })
    }

    if (inlinedToComposition) return

    if (isExpanded) {
      dispatch({ type: 'EXPAND', id: element.id })
    }
  }, [dispatch, element.id, inlinedToComposition, isExpanded, isSelected])

  if (!element.metadata) {
    console.warn('TOCMenuItem has no metadata', element)
    return null
  }

  const activityPart = element.metadata.activityPart

  const name = activityPart.childActivity.name
  const code = activityPart.childActivity.code
  const activityType = activityPart.childActivity.type

  return (
    <TOCMenuItemComponent
      name={name}
      code={code}
      isDraft={isDraft}
      isLocked={isLocked}
      isCompleted={isCompleted}
      isPassed={isPassed}
      isOptional={isOptional}
      activityType={activityType}
    />
  )
})
